module.exports = __webpack_public_path__ + "static/media/tax_returns.475d3c23.svg";